module.exports = __webpack_public_path__ + "static/media/tip-three.f9514f8b.png";